module.exports = __webpack_public_path__ + "media/images/amenities_icons/alcohol-7fdb20b678e08a452f1c43d9cf206c4a.svg";